<script>
  export let data = { tags: [] },
    contact;

  const tags = data.tags || [];
</script>

<ul>
  {#each tags as tag}
    {#if tag}
      <li><b>{tag.label}</b></li>
    {/if}
  {/each}
</ul>
